module.exports = __webpack_public_path__ + "static/media/29EUNOG2.22d138f6.jpg";